import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  fetchSuggestions,
  fetchSuggestionDetails,
  clearSuggestionDetails,
  selectThemedSuggestions,
  selectThemedResponseType,
  selectSuggestionsLoading,
  selectSuggestionsError,
  selectSelectedSuggestion,
  selectSuggestionDetails,
  selectDetailsLoading,
  selectOpenAiTokens
} from "../../../../mainApp/features/DataSlice/dataSlice";
import {
  ChatbotForm,
  ChatbotInput,
  ChatbotButton,
  DocumentTypeSelector,
  ChatbotSuggestions,
  SuggestionsHeader,
  SuggestionsBox,
  SuggestionItem,
  SuggestionTitle,
  SuggestionDescription,
  ChatbotMessage,
  ChatbotError,
  LoadingElement,
} from "../styled";
import { SOCIAL_MEDIA_DETAILS_COST } from "../../Utility/tokenCosts";

const ThemedPostsTab = () => {
  const dispatch = useDispatch();
  const themedSuggestions = useSelector(selectThemedSuggestions);
  const themedResponseType = useSelector(selectThemedResponseType);
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const suggestionsError = useSelector(selectSuggestionsError);
  const selectedSuggestion = useSelector(selectSelectedSuggestion);
  const suggestionDetails = useSelector(selectSuggestionDetails);
  const detailsLoading = useSelector(selectDetailsLoading);
  const currentTokens = useSelector(selectOpenAiTokens);

  const [category, setCategory] = useState("");
  const [platform, setPlatform] = useState("instagram");
  const [themeType, setThemeType] = useState("poll");
  const [openAiTokens, setOpenAiTokensState] = useState(0);

  const validationToastId = 'themed-posts-tab-validation-toast';

  const platforms = [
    { value: "instagram", label: "Instagram" },
    { value: "threads", label: "Threads" },
    { value: "x", label: "X" },
    { value: "tiktok", label: "TikTok" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "youtube", label: "YouTube" },
  ];

  const themeTypes = [
    { value: "poll", label: "Post z głosowaniem" },
    { value: "motivational", label: "Post motywacyjny" },
    { value: "facts", label: "Post o ciekawostkach" },
    { value: "sales", label: "Post sprzedażowy" },
    { value: "follow", label: "Post zachęta do obserwowania" },
    { value: "advertising", label: "Post reklamowy" },
  ];

  useEffect(() => {
    if (currentTokens !== openAiTokens) {
      setOpenAiTokensState(currentTokens);
    }
  }, [currentTokens]);

  const handleCategoryChange = (e) => setCategory(e.target.value);
  const handlePlatformChange = (e) => setPlatform(e.target.value);
  const handleThemeTypeChange = (e) => setThemeType(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!category.trim()) {
      toast.error("Proszę podać kategorię.", { position: "top-center", toastId: validationToastId });
      return;
    }

    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < SOCIAL_MEDIA_DETAILS_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować posty.", toastOptions);
      return;
    }

    // dispatch(clearSuggestionDetails());
    dispatch(fetchSuggestions());
    dispatch({
      type: "FETCH_ADVANCED_SUGGESTIONS",
      payload: { category, platform, contentType: "themed", themeType },
    });
  };

  const handleSuggestionClick = (index) => {
    const toastOptions = {
      position: "top-center",
      toastId: validationToastId,
    };

    if (currentTokens < SOCIAL_MEDIA_DETAILS_COST) {
      toast.error("Masz za mało tokenów, aby zobaczyć szczegóły.", toastOptions);
      return;
    }

    dispatch(
      fetchSuggestionDetails({
        index,
        platform,
        contentType: "themed",
        themeType,
        category,
      })
    );
  };

  return (
    <>
      <ChatbotForm onSubmit={handleSubmit}>
        <ChatbotInput
          type="text"
          placeholder="Wpisz kategorię (np. fitness, gotowanie)"
          value={category}
          onChange={handleCategoryChange}
        />
        <DocumentTypeSelector value={platform} onChange={handlePlatformChange}>
          {platforms.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </DocumentTypeSelector>
        <DocumentTypeSelector value={themeType} onChange={handleThemeTypeChange}>
          {themeTypes.map((t) => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </DocumentTypeSelector>
        <ChatbotButton type="submit" disabled={suggestionsLoading} tokenCost={SOCIAL_MEDIA_DETAILS_COST}>
          Generuj posty
        </ChatbotButton>
      </ChatbotForm>

      {suggestionsLoading ? (
        <LoadingElement>Ładowanie</LoadingElement>
      ) : suggestionsError ? (
        <ChatbotError>{suggestionsError}</ChatbotError>
      ) : themedSuggestions && themedResponseType === "message" ? (
        <ChatbotMessage>{themedSuggestions}</ChatbotMessage>
      ) : Array.isArray(themedSuggestions) && themedResponseType === "suggestions" ? (
        <ChatbotSuggestions>
          <SuggestionsHeader>Propozycje treści:</SuggestionsHeader>
          <SuggestionsBox>
            {themedSuggestions.map((suggestion, index) => (
              <SuggestionItem
                key={index}
                onClick={() => handleSuggestionClick(index)}
                style={{ cursor: "pointer" }}
                tokenCost={SOCIAL_MEDIA_DETAILS_COST}
              >
                {suggestion.title && (
                  <SuggestionTitle>{suggestion.title}</SuggestionTitle>
                )}
                <SuggestionDescription>{suggestion.description}</SuggestionDescription>
              </SuggestionItem>
            ))}
          </SuggestionsBox>
        </ChatbotSuggestions>
      ) : (
        <ChatbotMessage>Brak sugestii lub wystąpił błąd.</ChatbotMessage>
      )}

      {typeof selectedSuggestion === "number" && suggestionDetails && !detailsLoading && (
        <></>
      )}
    </>
  );
};

export default ThemedPostsTab;